import React, { useMemo } from "react";

import { PageLoader, Typography } from "clearsense-ui/components";

import Chart from "./Chart";
import { getChartData } from "./data";

const VariableFunnel = ({ data, isLoading }) => {
  const chartData = useMemo(() => data && getChartData(data), [data]);

  return (
    <div className="flex flex-col w-full bg-white dark:bg-gray-800 border-2 h-96">
      <div className="flex-none px-6 py-4 border-b-2">
        <Typography style="h3" type="semibold">
          Variable Funnel
        </Typography>
      </div>

      {isLoading ? (
        <div className="flex-1">
          <PageLoader />
        </div>
      ) : chartData ? (
        <Chart data={chartData} />
      ) : (
        <div className="flex items-center justify-center flex-1">
          <Typography>Failed to Load data</Typography>
        </div>
      )}
    </div>
  );
};

export default VariableFunnel;
